<template>
  <tr class="cabinet__tbody-row">
    <td class="cabinet__tbody-column cabinet__tbody-column--number">
      {{ item.code }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--name">
      <p>{{ item.name }}</p>
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--name">
      {{ item.address }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--tooltip">
      <button
        class="action-item"
        :class="{
          'tooltip__list-item-img--show': !isEdited,
          'tooltip__list-item-img--close': isEdited
        }"
        @click="toggle"
      />
    </td>
  </tr>
  <tr v-show="isEdited">
    <td
      class="objects-table__edit"
      colspan="4"
    >
      <div class="object-details">
        <div class="object-details__tabs">
          <button
            class="object-details__tabs-item"
            :class="{ 'object-details__tabs-item--selected': activeTab === 'contractors' }"
            @click="setActiveTab('contractors')"
          >
            Подрядчики
          </button>
          <button
            class="object-details__tabs-item"
            :class="{ 'object-details__tabs-item--selected': activeTab === 'storages' }"
            @click="setActiveTab('storages')"
          >
            Склады
          </button>
          <button
            class="object-details__tabs-item"
            :class="{ 'object-details__tabs-item--selected': activeTab === 'customers' }"
            @click="setActiveTab('customers')"
          >
            Заказчики
          </button>
        </div>

        <!--Подрядчики-->
        <div
          v-if="activeTab === 'contractors'"
          class="object-details__contractors"
        >
          <div
            v-if="contractors && contractors.length"
            class="object-details__contractors-table contractors-table"
          >
            <div class="contractors-table__head contractors-table-template">
              <div class="contractors-table__head-item">
                ИНН
              </div>
              <div class="contractors-table__head-item">
                Наименование подрядчика
              </div>
              <div class="contractors-table__head-item" />
            </div>
            <div class="contractors-table__body contractors-table-template">
              <template
                v-for="(contractor, index) of contractors"
                :key="index"
              >
                <div class="contractors-table__body-item">
                  {{ contractor.inn }}
                </div>
                <div class="contractors-table__body-item">
                  <SimpleSelect
                    :api="contractorsApi"
                    :default="contractor.title"
                    @selected="_changeContractors($event.key, $event.title, index)"
                  />
                </div>
                <div class="contractors-table__body-item">
                  <!--                  <template v-if="contractor.new">-->
                  <button
                    class="action-item tooltip__list-item-img--delete"
                    @click="deleteContractor({id: item.id, index})"
                  />
                  <!--                  </template>-->
                </div>
              </template>
            </div>
          </div>
          <a
            class="contractors-table__add-button"
            @click="addContractors(item.id)"
          >
            <PlusIcon size="18" />
            Добавить подрядчика
          </a>
          <div class="object-details__contractors-actions">
            <div class="col-12 col-md-4 col-xl-3">
              <button
                class="purchases__button"
                @click="_saveObjectContractors"
              >
                Сохранить
              </button>
            </div>
          </div>
        </div>

        <!--Склады-->
        <div
          v-if="activeTab === 'storages'"
          class="object-details__storages"
        >
          <!--          <h3 class="object-details__title">Склады</h3>-->
          <div
            v-if="storages && storages.length"
            class="object-details__storages-table storages-table"
          >
            <div class="storages-table__head storages-table-template">
              <div class="storages-table__head-item">
                Код склада
              </div>
              <div class="storages-table__head-item">
                Наименование объекта поставки
              </div>
              <div class="storages-table__head-item">
                Местоположение объекта поставки
              </div>
            </div>
            <div class="storages-table__body storages-table-template">
              <template
                v-for="store of storages"
                :key="store.id"
              >
                <div class="storages-table__body-item">
                  {{ store.code }}
                </div>
                <div class="storages-table__body-item">
                  {{ store.title }}
                </div>
                <div class="storages-table__body-item">
                  {{ store.address }}
                </div>
              </template>
            </div>
          </div>
        </div>

        <!--Заказчики-->
        <div v-if="activeTab === 'customers'">
          <div
            v-for="item in customersList"
            :key="item.id"
            class="customer-item"
          >
            <div class="customer-item-title">
              {{ item.name }}
            </div>

            <table class="cabinet__table customer-item-table">
              <thead class="cabinet__thead">
                <tr>
                  <th>
                    Рассылка
                  </th>
                  <th>
                    ФИО
                  </th>
                  <th>
                    E-mail
                  </th>
                </tr>
              </thead>
              <tbody class="cabinet__tbody">
                <tr
                  v-for="user in item.users"
                  :key="user.id"
                  class="cabinet__tbody-row"
                >
                  <td
                    class="cabinet__tbody-column cabinet__tbody-column--name"
                    style="width: 8%;"
                  >
                    <CheckboxForm
                      label="&nbsp;"
                      :value="!!user.isNeedSend"
                      @update:value="onCheckChanged(user, $event)"
                    />
                  </td>
                  <td
                    class="cabinet__tbody-column cabinet__tbody-column--name"
                    style="width: 30%;"
                  >
                    {{ user.fullName }}
                  </td>
                  <td
                    class="cabinet__tbody-column cabinet__tbody-column--tooltip"
                    style="width: 30%;"
                  >
                    {{ user.email }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="object-details__contractors-actions">
            <div class="col-12 col-md-4 col-xl-3">
              <button
                class="purchases__button"
                @click="saveCustomers"
              >
                Сохранить
              </button>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import useObjectData from '@/composables/useObjectData';
import PlusIcon from '@/components/icons/PlusIcon';
import api from '@/api';
import SimpleSelect from '@/components/elements/SimpleSelect';
import CheckboxForm from '@/components/form/checkbox-form.vue';

export default {
  name: 'OrganizationsTableItem',
  components: { PlusIcon, SimpleSelect, CheckboxForm },
  props: {
    item: {
      type: Object,
    },
  },
  setup(props) {
    const { storages, contractors } = useObjectData(props.item.id);
    return { storages, contractors };
  },
  data() {
    return {
      isEdited: false,
      activeTab: 'contractors',
      unSelectedUsers: {},
    };
  },
  created() {
    const unwatch = this.$watch('isEdited', async () => {
      await this.loadObjectDetails({ id: this.item.id });

      this.unSelectedUsers = (this.customersList || []).reduce((acc, item) => {
        const idsList = item.users.filter((user) => !user.isNeedSend).map((us) => us.id);

        if (idsList.length) {
          idsList.forEach((id) => {
            acc[id] = true;
          });
        }

        return acc;
      }, {});
      unwatch();
    });
  },
  computed: {
    ...mapState({
      customersList: (state) => state.admin.customersList,
    }),
  },
  methods: {
    ...mapActions('admin', ['loadObjectDetails', 'saveObjectContractors', 'saveCustomersList']),
    ...mapMutations('admin', ['addContractors', 'changeContractors', 'deleteContractor']),
    async toggle() {
      this.isEdited = !this.isEdited;
    },
    setActiveTab(tabName) {
      this.activeTab = tabName;
    },
    async contractorsApi(searchValue) {
      const result = await api.admin.contractors.search(searchValue);
      return result.data.result.map((contractor) => ({
        key: contractor.id,
        title: contractor.title,
      }));
    },
    _changeContractors(id, title, index) {
      this.changeContractors({
        objectId: this.item.id,
        index,
        id,
        title,
      });
    },
    _saveObjectContractors() {
      this.saveObjectContractors(this.item.id);
    },
    onCheckChanged(user, value) {
      if (value) {
        delete this.unSelectedUsers[user.id];
      } else {
        this.unSelectedUsers[user.id] = true;
      }
    },
    saveCustomers() {
      this.saveCustomersList({
        objectId: this.item.id,
        userIds: Object.keys(this.unSelectedUsers),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.object-details {
  padding: 25px 50px;
}
.object-details__tabs {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.object-details__tabs-item {
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  appearance: none;
  border: 0;
  border-radius: 10px;
  position: relative;
  padding: 14px 14px 14px 48px;
  width: 300px;
  height: 50px;
  color: #359652;
  background-color: $color-gray-input;
  cursor: pointer;
  &::after {
    content: "";
    position: absolute;
    left: 17px;
    top: 14px;
    width: 23px;
    height: 23px;
    border: 2px solid #359652;
    border-radius: 100%;
    background-color: #ffffff;
    opacity: 1;
  }
}

.object-details__tabs-item--selected {
  &::after {
    border: 6px solid #359652;
  }
}

.object-details__title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #359652;
}

.storages-table {
  width: min-content;
  margin: 20px auto 0;
}

.storages-table-template {
  display: grid;
  grid-template-columns: 170px 200px 580px;
  grid-template-rows: minmax(70px, auto);
}

.storages-table__head {
  color: #808388;
  font-weight: 600;
  background-color: $color-white;
}

.storages-table__body {
  margin-top: 3px;
}

.storages-table__head-item,
.storages-table__body-item {
  align-self: center;
  padding: 0 10px;
}

.storages-table__body-item {
  min-height: 70px;
  display: flex;
  align-items: center;
  background-color: $color-white;
}

.storages-table__body-item {
  &:nth-child(6n+1), &:nth-child(6n+2), &:nth-child(6n+3) {
    background-color: #fbfbfd;
  }
}

.contractors-table {
  width: min-content;
  margin: 20px auto 0;
}

.contractors-table-template {
  display: grid;
  grid-template-columns: 120px 500px 50px;
  grid-template-rows: minmax(70px, auto);
}

.contractors-table__head {
  color: #808388;
  font-weight: 600;
  background-color: $color-white;
}

.contractors-table__body {
  margin-top: 3px;
}

.contractors-table__head-item,
.contractors-table__body-item {
  align-self: center;
  padding: 0 10px;
}

.contractors-table__body-item {
  min-height: 70px;
  display: flex;
  align-items: center;
  background-color: $color-white;
}

.contractors-table__add-button {
  display: inline-block;
  padding-left: 28px;
  font-size: 16px;
  line-height: 140%;
  letter-spacing: 0.01em;
  color: $color-green-primary;
  margin: 20px 0 0 50px;
  position: relative;
  cursor: pointer;
  svg {
    position: absolute;
    left: 0;
    top: 2px;
  }
}

.object-details__contractors-actions {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}

.customer-item {
  margin-top: 30px;

  &-title {
    font-weight: 600;
    font-size: 18px;
    line-height: 140%;
    letter-spacing: 0.01em;
    color: #359652;
    margin-bottom: 30px;
  }

  &-table {
    max-width: 900px;
  }
}
</style>
